module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('page-title', {
    attrs: {
      "moduleIdentifier": _vm.moduleIdentifier,
      "image": _vm.listLogo,
      "title": _vm.listTitle
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_vm._t("header-actions")], 2)], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.filterTitle
    }
  }, [_c('span', {
    staticClass: "badge badge--default",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$tc('items.found.label', _vm.total, {
    count: _vm.total
  })))]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_vm._t("filters")], 2), _vm._v(" "), _c('div', {
    staticClass: "u-textRight"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n        Limpar filtros\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_c('i', {
    staticClass: "icon-search size"
  }), _vm._v("\n        Pesquisar\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "inline-flex"
  }, [_vm._t("top-actions"), _vm._v(" "), (_vm.sortDefault && _vm.sortFields) ? _c('div', [_c('sort-select', {
    ref: "sortSelect",
    staticClass: "margin-right",
    attrs: {
      "fields": _vm.sortFields,
      "sortDefault": _vm.options.sortOrder,
      "fieldDefault": _vm.options.sortField
    },
    on: {
      "change": _vm.onChangeSort
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sort-numeric', {
    ref: "sortNumeric",
    staticClass: "margin-right",
    on: {
      "change": _vm.onChangeQuantityPage
    }
  }), _vm._v(" "), _c('type-list', {
    ref: "typeList",
    staticClass: "margin-right",
    attrs: {
      "typesListAvailable": _vm.typesListAvailable
    },
    on: {
      "change": _vm.onChangeListPage
    }
  })], 2)]), _vm._v(" "), (_vm.$slots['top-actions-left-bottom'] || _vm.$slots['top-actions-right-bottom']) ? _c('div', {
    staticClass: "l-col-12@md margin-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_vm._t("top-actions-left-bottom")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("top-actions-right-bottom")], 2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_vm._t("bottom-actions")], 2), _vm._v(" "), _c('div', {
    staticClass: "paginator"
  }, [_c('paginator', {
    ref: "paginator",
    attrs: {
      "total": _vm.total,
      "limit": _vm.options.limit
    },
    on: {
      "change": _vm.onChangePage
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a8eaf8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/list/Paginator.vue
// module id = 2938
// module chunks = 0